import { Component, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { RouterOutlet, Router, NavigationStart, NavigationEnd } from '@angular/router';
import { CommonModule, isPlatformBrowser, ViewportScroller } from '@angular/common';
import { NavbarComponent } from './core/components/navbar/navbar.component';
import { LoadingScreenComponent } from './core/components/loading-screen/loading-screen.component';
import { LoadingService } from './core/services/loading.service';
import { ReferralTrackingService } from './shared/services/referral-tracking.service';
import { Observable } from 'rxjs';
import { FooterComponent } from '@core/components/footer/footer.component';
import { filter } from 'rxjs/operators';
import { Title } from '@angular/platform-browser';
import { VisitorChatComponent } from './shared/components/visitor-chat/visitor-chat.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    NavbarComponent,
    LoadingScreenComponent,
    FooterComponent,
    VisitorChatComponent
  ],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  loading$: Observable<boolean>;
  isAdminRoute = false;
  isFunnelRoute = false;
  isMaintenanceRoute = false;
  showVisitorChat = true;

  constructor(
    private router: Router,
    private loadingService: LoadingService,
    private referralTrackingService: ReferralTrackingService,
    private viewportScroller: ViewportScroller,
    @Inject(PLATFORM_ID) private platformId: Object,
    private titleService: Title
  ) {
    this.loading$ = this.loadingService.isLoading$;
  }

  ngOnInit() {
    // Loading-Screen-Logik
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        // Only show loading screen for non-admin and non-dashboard routes
        const isAdminNavigation = event.url.startsWith('/admin');
        const isDashboardNavigation = event.url.startsWith('/dashboard');
        const isHelpcenterNavigation = event.url.startsWith('/helpcenter');
        const isMaintenanceNavigation = event.url.startsWith('/maintenance');
        if (!isAdminNavigation && !isDashboardNavigation && !isHelpcenterNavigation && !isMaintenanceNavigation) {
          this.loadingService.show();
          setTimeout(() => {
            this.loadingService.hide();
          }, 1000);
        }
      }
      
      // Check route for visibility conditions
      if (event instanceof NavigationEnd) {
        this.isAdminRoute = this.router.url.startsWith('/admin');
        this.isFunnelRoute = this.router.url.startsWith('/bewerben');
        this.isMaintenanceRoute = this.router.url.startsWith('/maintenance');
        
        // Hide visitor chat on admin, dashboard, shop, funnel, and maintenance routes
        this.showVisitorChat = !(
          this.router.url.startsWith('/admin') ||
          this.router.url.startsWith('/dashboard') ||
          this.router.url.startsWith('/shop') ||
          this.router.url.startsWith('/bewerben') ||
          this.router.url.startsWith('/maintenance')
        );
      }
    });

    // Scroll-nach-oben-Logik
    if (isPlatformBrowser(this.platformId)) {
      this.router.events.pipe(
        filter(event => event instanceof NavigationEnd)
      ).subscribe(() => {
        this.viewportScroller.scrollToPosition([0, 0]);
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
        
        // Title setzen basierend auf aktueller Route
        const currentRoute = this.router.url.split('/')[1];
        let pageTitle = 'Home';
        
        switch(currentRoute) {
          case '':
            pageTitle = 'Home';
            break;
          case 'produkte':
            pageTitle = 'Produkte';
            break;
          case 'ueber-uns':
            pageTitle = 'Über uns';
            break;
          case 'blog':
            pageTitle = 'Blog';
            break;
          case 'events':
            pageTitle = 'Events';
            break;
          case 'shop':
            pageTitle = 'Shop';
            break;
          case 'dashboard':
            pageTitle = 'Dashboard';
            break;
          case 'agb':
            pageTitle = 'AGB';
            break;
          case 'widerruf':
            pageTitle = 'Widerruf';
            break;
          case 'disclaimer':
            pageTitle = 'Disclaimer';
            break;
          case 'impressum':
            pageTitle = 'Impressum';
            break;
          case 'datenschutz':
            pageTitle = 'Datenschutz';
            break;
          case 'faq':
            pageTitle = 'FAQ';
            break;
          default:
            pageTitle = 'Home';
        }
        
        this.titleService.setTitle(`${pageTitle} | HORIZON NET Consulting`);
      });
    }
  }
}
